module.exports = __webpack_public_path__ + "static/media/avatar-3.6611dbdc.jpg";